import { MembershipType } from 'type';

// New members (Dynamics status 'New') are registering for the first time,
// not renewing - the portal shows join/registration messaging instead of
// renewal messaging for them.
export const isNewMembership = (membership?: MembershipType | null) =>
  membership?.status === 'New';

// Shown in place of the renewal (due/overdue) message for new members.
export const NEW_MEMBER_ALERT_MESSAGE =
  'Your membership application is ready to be finalised.';
